import { getRandomString } from '@/utils/random-string'
import { COUNTRIES } from '@/services/countries'
import _ from 'lodash'
import { stagesChoices } from '@/services/stages'
import { sectorValuesList } from '@/services/sectors'

export function getEmptyStartup() {
  return {
    id: '',
    name: '',
    slug: '',
    caption: '',
    website: '',
    bg_img_url: '',
    bg_colors: ['#333333', '#444444'],
    logo_url: '',
    amount_raising: '',
    sector: '',
    primary_sector: '',
    secondary_sector: '',
    sectors: [],
    business_type: [],
    product_type: [],
    city: '',
    country: '',
    pitch: [],
    members: [],
    documents: [],
    startups: [],
    extra_data: { person: {}, revenues: {} },
    employees_count: 0,
    stage: null,

    round_type: null,
    round_size: null,
    round_securities: [],
    round_sources: [],

    previous_rounds: [],
    faq: [],
    features: {
      links: false,
      all_discounts: false,
    },
    ratings: {
      overall: {
        value: null,
        note: null,
      },
    },

    already_committed: null,
    already_committed_investors: null,

    video_url: null,
  }
}

export function getObfuscatedStartup() {
  const startup = getEmptyStartup()
  return {
    ...startup,
    id: getRandomString(),
    is_obfuscated: true,
    name: getRandomString(),
    caption: Array(30)
      .fill()
      .map((i) => getRandomString())
      .join(' '),
    city: getRandomString(),
    country: _.sample(COUNTRIES).value,
    stage: _.sample(stagesChoices).value,
    sectors: _.sampleSize(sectorValuesList, _.random(1, 3)),
  }
}
